import axios from '../plugins/axios-instance'

export const setUserData = ({ commit }, { userData }) => {
  commit('SET_USER_DATA', { userData })
}

export const updateUserToken = ({ commit }, { newToken }) => {
  commit('UPDATE_USER_TOKEN', { newToken })
}

export const updateReports = ({ commit }, { updateReports }) => {
  commit('UPDATE_REPORTS', { updateReports })
}

export const showOverlay = ({ commit }, { show }) => {
  commit('SHOW_OVERLAY', { show })
}

export const setError = ({ commit }, { errorMsg }) => {
  commit('SET_ERROR', { errorMsg })
}

export const setSuccess = ({ commit }, { successMsg }) => {
  commit('SET_SUCCESS', { successMsg })
}

export const setInfo = ({ commit }, { infoMsg }) => {
  commit('SET_INFO', { infoMsg })
}

export const setSettings = ({ commit }, { settings }) => {
  commit('SET_SETTINGS', { settings })
}

export const setTotalReports = ({ commit }, { total }) => {
  commit('SET_TOTAL_REPORTS', { total })
}

export const showSettings = ({ commit }, { show }) => {
  commit('SHOW_SETTINGS', { show })
}

export const setSelectedProject = ({ commit }, { selectedProject }) => {
  commit('SET_SELECTED_PROJECT', { selectedProject })
}

export const setSelectedProjectName = ({ commit }, { selectedProjectName }) => {
  commit('SET_SELECTED_PROJECT_NAME', { selectedProjectName })
}

export const setCurrentTasksList = ({ commit }, { tasksList }) => {
  commit('SET_CURRENT_TASKS_LIST', { tasksList })
}

export const setCurrentTaskData = ({ commit }, { taskData }) => {
  commit('SET_CURRENT_TASK_DATA', { taskData })
}

export const setEmployeeList = ({ commit }, { employeeList }) => {
  commit('SET_EMPLOYEE_LIST', { employeeList })
}

export const getEmployeeList = ({ commit, dispatch, getters }) => {
  axios.get('/api/employeelist', {
    headers: {
      Authorization: 'Bearer ' + getters.getUser.token
    }
  }).then(response => {
    commit('SET_EMPLOYEE_LIST', { employeeList: response.data })
  }).catch(error => {
    dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
  })
}

export const getAccessToCreateTasksEmpl = ({ commit, dispatch, getters }, { projectID, taskID }) => {
  axios.get(`/api/tasks/access-to-create-tasks/${projectID}/${taskID}`, {
    headers: {
      Authorization: 'Bearer ' + getters.getUser.token
    }
  }).then(response => {
    commit('SET_ACCESS_TO_CREATE_TASK_EMPL_LIST', { emplList: response.data.map(e => e.Employee_ID) })
  }).catch(error => {
    dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
  })
}

export const updateTask = ({ commit }, { taskID, self, newData }) => {
  commit('UPDATE_TASK', { taskID, self, newData })
}

export const taskUpdated = ({ commit }) => {
  commit('TASK_UPDATED')
}

export const updAccessToCreateTasksEmpl = ({ commit }, { emplList }) => {
  commit('SET_ACCESS_TO_CREATE_TASK_EMPL_LIST', { emplList: emplList })
}

export const showTaskDialog = ({ commit }, { show }) => {
  commit('SHOW_TASK_DIALOG', { show })
}

export const showDetailsDialog = ({ commit }, { show }) => {
  commit('SHOW_DETAILS_DIALOG', { show })
}

export const showConfirmDeniedDialog = ({ commit }, { show }) => {
  commit('SHOW_CONFIRM_DENIED_DIALOG', { show })
}

export const updateTasks = ({ commit }, { update }) => {
  commit('UPDATE_TASKS', { update })
}

export const addUserOnProject = ({ commit }, { userId }) => {
  commit('ADD_USER_ON_PROJECT', { userId })
}

export const addParentTaskOnProject = ({ commit }, { parentTask }) => {
  commit('ADD_PARENT_TASK_ON_PROJECT', { parentTask })
}

export const setUsersOnProject = ({ commit }, { users }) => {
  commit('SET_USERS_ON_PROJECT', { users })
}

export const removeUsersOnProject = ({ commit }) => {
  commit('REMOVE_USERS_ON_PROJECT')
}

export const removeParentTasksOnProject = ({ commit }) => {
  commit('REMOVE_PARENT_TASKS_ON_PROJECT')
}

export const isDragging = ({ commit }, { dragging }) => {
  commit('IS_DRAGGING', { dragging })
}

export const updateStateOfOpenedFolders = ({ commit }, { taskId, isOpen }) => {
  commit('UPDATE_STATE_OF_OPENED_FOLDERS', { taskId, isOpen })
}

export const saveEmployeeInformation = ({ commit }, { employee }) => {
  commit('SAVE_EMPLOYEE_INFORMATION', { employee })
}

export const addEmployee = ({ commit }, { employee }) => {
  commit('ADD_EMPLOYEE', { employee })
}

export const addEmployeeStatus = ({ commit }, { employeeId, status }) => {
  commit('ADD_EMPLOYEE_STATUS', { employeeId, status })
}

export const updateEmployeeStatus = ({ commit }, { employeeId, statuses }) => {
  commit('UPDATE_EMPLOYEE_STATUS', { employeeId, statuses })
}

export const removeEmployeeStatus = ({ commit }, { employeeId, index }) => {
  commit('REMOVE_EMPLOYEE_STATUS', { employeeId, index })
}

export const setEmployeeRate = ({ commit }, { rate, employeeId }) => {
  commit('SET_EMPLOYEE_RATE', { rate, employeeId })
}
export const addEmployeeRate = ({ commit }, { rate }) => {
  commit('ADD_EMPLOYEE_RATE', { rate })
}

export const updateEmployeeRate = ({ commit }, { rate }) => {
  commit('UPDATE_EMPLOYEE_RATE', { rate })
}

export const removeEmployeeRate = ({ commit }, { rate }) => {
  commit('REMOVE_EMPLOYEE_RATE', { rate })
}

export const updateEmployee = ({ commit }, { employee }) => {
  commit('UPDATE_EMPLOYEE', { employee })
}

export const addEstRepForTask = ({ commit }, { taskId, est, rep }) => {
  commit('ADD_EST_REP_FOR_TASK', { taskId, est, rep })
}

export const setStatuses = ({ commit }, { statuses }) => {
  commit('SET_STATUSES', { statuses })
}

export const setActivityTypes = ({ commit }, { activityTypes }) => {
  commit('SET_ACTIVITY_TYPES', { activityTypes })
}

export const setPermissions = ({ commit }, { permissionsFor, permissions }) => {
  commit('SET_PERMISSIONS', { permissionsFor, permissions })
}

export const setDepartments = ({ commit }, { departments }) => {
  commit('SET_DEPARTMENTS', { departments })
}

export const setContractTypes = ({ commit }, { contractTypes }) => {
  commit('SET_CONTRACT_TYPES', { contractTypes })
}

export const setWorkLocations = ({ commit }, { locations }) => {
  commit('SET_WORK_LOCATIONS', { locations })
}

export const setClients = ({ commit }, { clients }) => {
  commit('SET_CLIENTS', { clients })
}

export const addClient = ({ commit }, { client }) => {
  commit('ADD_CLIENT', { client })
}

export const updateClient = ({ commit }, { client }) => {
  commit('UPDATE_CLIENT', { client })
}

export const setProjects = async ({ commit, dispatch, getters }, { projects }) => {
  if (projects) {
    commit('SET_PROJECTS', { projects })
  } else {
    const t = getters.getUser.token
    await axios.get('/api/projects', {
      headers: {
        Authorization: 'Bearer ' + t
      }
    }).then(async responseProjects => {
      await axios.get('/api/permissions/2', {
        headers: {
          Authorization: 'Bearer ' + t
        }
      }).then(res => {
        dispatch('setPermissions', { permissionsFor: 'projects', permissions: res.data })
        const proj = []
        for (let i = 0; i < responseProjects.data.length; i++) {
          let integratedWith = ''
          if (responseProjects.data[i].Integrated_With_Jira) integratedWith = 'Jira'
          if (responseProjects.data[i].Integrated_With_Redmine) integratedWith = 'Redmine'
          proj.push({
            ...responseProjects.data[i],
            Integrated_With: integratedWith
          })
          commit('SET_PROJECTS', { projects: proj })
        }
      }).catch(error => {
        dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    }).catch(error => {
      dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
    })
  }
}

export const addProject = ({ commit }, { project }) => {
  commit('ADD_PROJECT', { project })
}

export const updateProject = ({ commit }, { project }) => {
  commit('UPDATE_PROJECT', { project })
}

export const setProjectStatuses = ({ commit }, { projectStatuses }) => {
  commit('SET_PROJECT_STATUSES', { projectStatuses })
}

export const setManagersForProject = ({ commit }, { projectId, managers }) => {
  commit('SET_MANAGERS_FOR_PROJECT', { projectId, managers })
}

export const setRateHistoryForProject = ({ commit }, { projectId, history }) => {
  commit('SET_RATE_HISTORY_FOR_PROJECT', { projectId, history })
}

export const setNotifications = ({ commit }, { notifications }) => {
  commit('SET_NOTIFICATIONS', { notifications })
}

export const setEmployeeRoles = ({ commit }, { roles }) => {
  commit('SET_EMPLOYEE_ROLES', { roles })
}

export const setEmailConfigElement = ({ commit }, { element }) => {
  commit('SET_EMAIL_CONFIG_ELEMENT', { element })
}

export const setEmailTemplatesList = ({ commit }, { emailTemplatesList }) => {
  commit('SET_EMAIL_TEMPLATES_LIST', { emailTemplatesList })
}

export const updateEmailTemplate = ({ commit }, { template }) => {
  commit('UPDATE_EMAIL_TEMPLATE', { template })
}

export const addEmailTemplate = ({ commit }, { template }) => {
  commit('ADD_EMAIL_TEMPLATE', { template })
}

export const removeEmailTemplate = ({ commit }, { templateID }) => {
  commit('REMOVE_EMAIL_TEMPLATE', { templateID })
}

export const toggleEmployeeFullNameButton = ({ commit }) => {
  commit('TOGGLE_EMPLOYEE_FULL_NAME_BUTTON')
}

export const updatePolicy = ({ commit }, { policy }) => {
  commit('UPDATE_POLICY', { policy })
}

export const addPolicy = ({ commit }, { policy }) => {
  commit('ADD_POLICY', { policy })
}

export const setPolicies = ({ commit }, { policies }) => {
  commit('SET_POLICIES', { policies })
}

export const setPolicyUsers = ({ commit }, { policyUsers }) => {
  commit('SET_POLICY_USERS', { policyUsers })
}

export const removePolicy = ({ commit }, { policyId }) => {
  commit('REMOVE_POLICY', { policyId })
}

export const blockProject = ({ commit }, { projectID }) => {
  commit('BLOCK_PROJECT', { projectID })
}

export const toggleTaskToSelected = ({ commit }, { task, action }) => {
  commit('TOGGLE_TASK_TO_SELECTED', { task, action })
}

export const setDivisionList = ({ commit }, { divisions }) => {
  commit('SET_DIVISION_LIST', { divisions })
}

export const setInvoices = ({ commit }, { invoices }) => {
  commit('SET_INVOICES', { invoices })
}

export const updateInvoice = ({ commit }, { invoice }) => {
  commit('UPDATE_INVOICE', { invoice })
}

export const addInvoice = ({ commit }, { invoice }) => {
  commit('ADD_INVOICE', { invoice })
}

export const updateSalary = ({ commit }, { update }) => {
  commit('UPDATE_SALARY', { update })
}

export const employeeDetailsScreen = ({ commit }, { show, employee, edit }) => {
  commit('EMPLOYEE_DETAILS_SCREEN', { show, employee, edit })
}

export const projectDetailsScreen = ({ commit }, { show, project }) => {
  commit('PROJECT_DETAILS_SCREEN', { show, project })
}

export const clientDetailsScreen = ({ commit }, { show, client }) => {
  commit('CLIENT_DETAILS_SCREEN', { show, client })
}

export const showEditTaskOrFolderDialog = ({ commit }, { show, data }) => {
  commit('SHOW_EDIT_TASK_OR_FOLDER_DIALOG', { show, data })
}

export const setAlertAboutDeleteDialogData = ({ commit }, { show, data }) => {
  commit('SET_ALERT_ABOUT_DELETE_DIALOG_DATA', { show, data })
}

export const updateReportsList = ({ commit }, { update }) => {
  commit('UPDATE_REPORTS_LIST', { update })
}

export const updateManagerReportState = ({ commit }, { key, value }) => {
  commit('UPDATE_MANAGER_REPORT_STATE', { key, value })
}

export const assetDetailsScreen = ({ commit }, { show, asset, categories, subcategories }) => {
  commit('ASSET_DETAILS_SCREEN', { show, asset, categories, subcategories })
}

export const setProjectDetailsDialogState = ({ commit }, { _state }) => {
  commit('SET_PROJECT_DETAILS_DIALOG_STATE', { _state })
}

export const setCurrentUserPosition = ({ commit }, { employeePosition }) => {
  commit('SET_CURRENT_USER_POSITION', { employeePosition })
}

export const setIsLoading = ({ commit }, { setIsLoading }) => {
  commit('SET_IS_LOADING', { isLoading: setIsLoading })
}
